import React from 'react';
import { connect } from 'react-redux';
import {
    ROUTE_EDIT_PROFILE, ROUTE_PROFILE, ROUTE_PROFILE_CURRENT
} from '../../../constants/routeconstants';
import * as AuthActions from '../../../actions/auth';
import * as UserActions from '../../../actions/user';
import * as SystemActions from '../../../actions/system';
import UserRoles from '../../../../../common/src/enums/UserRoles';
import {NotificationManager} from "react-notifications";
import ProfileForm from '../../reusable/profile/ProfileForm';
import {push} from "react-router-redux";

class EditProfilePage extends React.Component {

    static getId() {
        return ROUTE_EDIT_PROFILE;
    }

    static getAllowedRoles() {
        return [];
    }

    constructor(props) {
        super(props);
        this.state = {
            user: null
        }
    }

    componentDidMount() {
        this.loadUser(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.userId !== this.props.params.userId) this.loadUser(nextProps);
        else {
            const userId = this.getUserId(nextProps);
            const user = nextProps.user.users.get(userId);
            if (user && typeof(user.photo) != 'undefined') this.setState({user: user});
        }
    }

    loadUser = props => {
        const userId = this.getUserId(props);
        const user = this.props.user.users.get(userId);
        if (!user || typeof(user.photo) == 'undefined') {
            this.props.dispatch(UserActions.getUser(userId, true));
            this.setState({user: null});
        }
        else this.setState({user: user});
    }

    render() {
        const user = this.state.user;
        return (
            <div className="edit-user-profile-page">
                {user ? [
                    <div className="sub-page-title" key="title">
                        <h1>Edit profile</h1>
                    </div>,
                    <div className="sub-page-content" key="content">
                        {user.id === this.props.auth.userId || this.props.auth.roleId & UserRoles.ADMIN.id ?
                            <ProfileForm profile={user} onSubmit={this.handleSubmit} submitButtonText="Save"
                                         params={this.props.location.query}/>
                            : <div className="page-error">No access</div>
                        }
                    </div>
                ] : ''}
            </div>
        );
    }

    handleSubmit = userProfile => {
        if (this.props.user.isSaving) return;
        const userId = this.getUserId(this.props);
        const onSuccess = () => {
            if (userId === this.props.auth.userId) NotificationManager.success("Your profile has been updated.", "Profile updated", 4000);
            else NotificationManager.success("The user has been updated.", "User updated", 4000);
            this.props.dispatch(SystemActions.updateImageCacheBreakerValue());
            if (userId == this.props.auth.userId) this.props.dispatch(push(ROUTE_PROFILE_CURRENT));
            else this.props.dispatch(push(ROUTE_PROFILE.replace(":userId", userId)))
        };
        if (userId === this.props.auth.userId) this.props.dispatch(AuthActions.updateProfile(userProfile, onSuccess));
        else this.props.dispatch(UserActions.updateUser(userId, userProfile, onSuccess));
    };

    getUserId = newestProps => {
        const userId = Number(newestProps.params.userId) || newestProps.auth.userId || null;
        if (userId === null) console.error("user not detected"); // should never happen during normal flow (maybe redirect to login-page in that case?)
        return userId;
    };
}

const mapStateToProps = (state) => ({
    user: {
        users: state.user.users,
        isSaving: state.user.isSaving,
    },
    auth: state.auth
});

export default connect(mapStateToProps)(EditProfilePage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/profile/EditProfilePage.js